/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;

      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  document.addEventListener('change', function(e){
    var el = e.target;

    if(el.classList.contains('upsell_product_main_select') || el.closest('.upsell_product_main_select')) {
      var selectedElement = el[el.selectedIndex];
      var variant_price = selectedElement.getAttribute('data-variant_price');
      var variant_compare_price = selectedElement.getAttribute('data-variant_compare_price');
      var variant_media = selectedElement.getAttribute('data-variant_media');
      var variant_media__alt = selectedElement.getAttribute('data-variant_media__alt');


      var productParentEl = el.closest('.upsell_product');
      var productMediaEl = productParentEl.querySelector('.upsell_product__image-wrapper img');
      var productPriceWrapper =  productParentEl.querySelector('.upsell_product__price-list');
      var discountLabel =    productParentEl.querySelector('.product-label');   

      productMediaEl.setAttribute('src',variant_media);
      productMediaEl.setAttribute('alt',variant_media__alt);

      productPriceWrapper.style.display = 'none';
      productPriceWrapper.innerHTML = '';

      if (variant_compare_price > variant_price) {
        productPriceWrapper.innerHTML += "<span class=\"price price--highlight\">".concat(formatMoney(variant_price, window.theme.moneyFormat)+"</span>");
        productPriceWrapper.innerHTML += "<span class=\"price price--compare\">".concat(formatMoney(variant_compare_price, window.theme.moneyFormat)+"</span>");
      } else {
        productPriceWrapper.innerHTML += "<span class=\"price\">".concat(formatMoney(variant_price, window.theme.moneyFormat)+"</span>");
      }
      productPriceWrapper.style.display = '';
      

      if (variant_compare_price > variant_price) {
      

        var savings = null;

        if (window.theme.discountMode === 'percentage') {
          savings = "".concat(Math.round((variant_compare_price - variant_price) * 100 / variant_compare_price), "%");
        } else {
          savings = "<span>".concat(formatMoney(variant_compare_price - variant_price, window.theme.moneyFormat), "</span>");
        }

        discountLabel.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace('{{savings}}', savings));
        discountLabel.style.display = 'inline-block';

      } else {
      	discountLabel.style.display = 'none';
      }
    }
       if(el.classList.contains('warranty-trigger')) {
        el.closest("label").classList.add("disabled_label");
          

           if(el.checked == true){

            var itemId = el.value * 1;
            var mainProductId = el.getAttribute("data-main-product-id");
          

             if(window.innerWidth > 1280){
              var quantityInput = el.closest('.line-item.line-item--stack').querySelector('.line-item__quantity.hidden-phone .quantity-selector__value');
            }else{
              var quantityInput = el.closest('.line-item.line-item--stack').querySelector('.line-item__quantity.hidden-tablet-and-up .quantity-selector__value');
            } 

            var quantity = quantityInput.value * 1; 
         
            var formData = {
              'items': [{
                'id': itemId,
                'quantity': quantity,
                'properties':{
                  "_Warranty for": mainProductId
                }
              }]
            };
      
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            }).then(function (response) {
              if (response.ok) {
                el.removeAttribute('disabled');
      
                if(window.theme.pageType != 'cart') {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                  }));
                } else {
        			location.reload();
                }
      
      
              } else {
                response.json().then(function (content) {
                  // var errorMessageElement = document.createElement('span');
                  // errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                  // errorMessageElement.innerHTML = content['description'];
                  // el.removeAttribute('disabled');
                  // el.insertAdjacentElement('afterend', errorMessageElement);
                  // setTimeout(function () {
                  //   errorMessageElement.remove();
                  // }, 2500);
                  console.log(content['description']);
                });
              }
            });
          }else{
                var itemId = el.value;
                var updates = {
                      'id': itemId,
                      'quantity': 0
                    }
              fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
            }).then(function (response) {
              if (response.ok) {
                el.removeAttribute('disabled');
      
                if(window.theme.pageType != 'cart') {
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                  }));
                } else {
        			location.reload();
                }
      
      
              } else {
                response.json().then(function (content) {
                  console.log(content['description']);
                });
              }
            });
             
             
          }

       }
      

    
  });
  document.addEventListener('click', function(e){
    var el = e.target;

    if(el.classList.contains('upsell_product_submit') || el.closest('.upsell_product_submit')) {
      if(!el.classList.contains('upsell_product_submit')) {
        el = el.closest('.upsell_product_submit');
      }
      el.setAttribute('disabled','disabled');
      if(window.innerWidth > 1280){
        var upsell_product_main_select = el.closest('.upsell_product').querySelector('.hidden-lap .upsell_product_main_select');
        var quantityInput = el.closest('.upsell_product').querySelector('.hidden-lap.upsell_product_qty__wrapper .quantity-selector__value');
      }else{
        var upsell_product_main_select = el.closest('.upsell_product').querySelector('.hidden-desk .upsell_product_main_select');
        var quantityInput = el.closest('.upsell_product').querySelector('.hidden-desk.quantity-selector .quantity-selector__value');
      }
      var itemId = upsell_product_main_select.value * 1;
      var quantity = quantityInput.value * 1;
      let formData = {
        'items': [{
          'id': itemId,
          'quantity': quantity
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        if (response.ok) {
          el.removeAttribute('disabled');

          if(window.theme.pageType != 'cart') {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          } else {
			location.reload();
          }


        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            el.removeAttribute('disabled');
            el.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });
    }
  });
  document.addEventListener('change', function(e){
    var el = e.target;

    if(el.classList.contains('related_product_block_check')) {
       e.preventDefault();
    var disabled_btn = true;
      var submitBtn = el.closest('.frequently_bought_together__block').querySelector('.add_selected_products');

      var total_price = 0;
      var total_saved_price = 0;
      el.closest('.frequently_bought_together__block').querySelectorAll('.related_product_block_check').forEach(function (item,index) {
        var checked = item.checked;
        if(checked) {

          var item_price = item.getAttribute('data-price') * 1;
          total_price = total_price + item_price;

           var item_compare_price = item.getAttribute('data-compare-price') * 1;
          total_saved_price = total_saved_price + item_compare_price;
          
          disabled_btn = false;
        }
      });
      if(submitBtn) {

        

        submitBtn.querySelector('.add_selected_products_price').innerHTML = formatMoney(total_price, window.theme.moneyFormat) ;
        if(disabled_btn) {
          submitBtn.setAttribute('disabled',true);
        } else {
          submitBtn.removeAttribute('disabled');
        }
      }

      var frequently_bought_together_saved_priceEL = el.closest('.frequently_bought_together__block').querySelector('.frequently_bought_together_saved_price');  
      if(frequently_bought_together_saved_priceEL) {
        total_saved_price = total_saved_price - total_price;
        if(total_saved_price > 0) {
          frequently_bought_together_saved_priceEL.querySelector('.total_saved_price').innerHTML = formatMoney(total_saved_price, window.theme.moneyFormat) ;
          frequently_bought_together_saved_priceEL.classList.remove('no-js');
        } else {
          frequently_bought_together_saved_priceEL.classList.add('no-js');
        }
        
      }
    }
    });
  document.addEventListener('click', function(e){
    var el = e.target;

    if(el.classList.contains('add_selected_products') || el.closest('.add_selected_products')) {
      if(!el.classList.contains('add_selected_products')) {
        el = el.closest('.add_selected_products');
      }
      el.setAttribute('disabled','disabled');

      var itemsArr = [];
      el.closest('.frequently_bought_together__block').querySelectorAll('.related_product_block_check').forEach(function (item,index) {
        var checked = item.checked;
        if(checked) {
         var itemData = {
          'id': item.value * 1,
          'quantity': 1
        }
          itemsArr.push(itemData);
        }
      });
        let formData = {
        'items': itemsArr
      };

      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function (response) {
        console.log(response);
        if (response.ok) {
          el.removeAttribute('disabled');

          //  el.querySelector('.add_selected_products_text').classList.add('no-js');
          // el.querySelector('.added_selected_products_text').classList.remove('no-js');
          

          // setTimeout(function () {

          //     el.querySelector('.added_selected_products_text').classList.add('no-js');
          //     el.querySelector('.add_selected_products_text').classList.remove('no-js');
            
          //   }, 2500);
          
         
          
          // if(window.theme.pageType != 'cart') {
          //   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          //     bubbles: true
          //   }));
          // } else {
          //   window.location.href = '/cart';
          // }

          window.location.href = '/cart';


        } else {
          response.json().then(function (content) {
            console.log(content);
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            el.removeAttribute('disabled');
            el.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });
    }
  });

  var frequently_bought_together__block = document.querySelector('.frequently_bought_together__block');
  if(frequently_bought_together__block) {
  //    document.addEventListener('variant:changed', function(event) {
  //   var variant = event.detail.variant; 

  //       var submit_selected_productsBtn = frequently_bought_together__block.querySelector('.add_selected_products'); 
  //   if(submit_selected_productsBtn) {
  //     if(variant.available) {
  //       submit_selected_productsBtn.classList.remove('disabled');
  //     } else {
  //       submit_selected_productsBtn.classList.add('disabled');
  //     }
  //   }
       
  //      var current_product_image_blockEl = frequently_bought_together__block.querySelector('.current_product_image_block');
  //      if(current_product_image_blockEl && variant.featured_media != null) {
  //        current_product_image_blockEl.querySelector('img').setAttribute('src',variant.featured_media.preview_image.src);
  //      }

  //      var variantBlockEl = frequently_bought_together__block.querySelector('.related_product_block.current_product');
  //      if(variantBlockEl) {
  //        var priceEl = variantBlockEl.querySelector('.price');
  //       var  variant_checkEl = variantBlockEl.querySelector('.related_product_block_check'); 

        

  //        variant_checkEl.value = variant.id;
  //         var prevPrice = priceEl.getAttribute('data-current-price') * 1;
  //        var prevComparePrice = priceEl.getAttribute('data-current-compare_at_price') * 1;
  //     var  currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;

         
  //        if(prevPrice == variant.price) {
  //        } else {

  //        priceEl.style.display = 'none';
  //        priceEl.innerHTML = '';

  //         if(variant.compare_at_price > variant.price) {

  //         var savings = null;
  //           if (window.theme.discountMode === 'percentage') {
  //           savings = "".concat(Math.round((variant['compare_at_price'] - variant['price']) * 100 / variant['compare_at_price']), "%");
  //         } else {
  //           savings = "<span>".concat(formatMoney(variant['compare_at_price'] - variant['price'], window.theme.moneyFormat), "</span>");
  //         }
  //           priceEl.innerHTML += "<span class=\"product-label product-label--on-sale\">".concat(window.languages.collectionOnSaleLabel.replace('{{savings}}', savings))+"</span>";

  //                       priceEl.innerHTML += "<span class=\"price price--highlight\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(variant['price'], currencyFormat), "</span>");
  //           priceEl.innerHTML += "<span class=\"price price--compare\"><span class=\"visually-hidden\">".concat(window.languages.productRegularPrice, "</span>").concat(formatMoney(variant['compare_at_price'], currencyFormat), "</span>");

            
  //         } else {
  //           priceEl.innerHTML += "<span class=\"price\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(variant['price'], currencyFormat), "</span>");
  //         }
  //       priceEl.removeAttribute('style');

  //          variant_checkEl.setAttribute('data-price',variant.price);
  //          variant_checkEl.setAttribute('data-compare-price',variant.compare_at_price);

  //               priceEl.setAttribute('data-current-price',variant.price);
  //               priceEl.setAttribute('data-current-compare_at_price',variant.compare_at_price);

  //            variant_checkEl.dispatchEvent(new Event('change', { bubbles: true }));
  //        }         
  //      }
       
      

       
  //     console.log(variant);
  // });

var related_product_selects = document.querySelectorAll(".related_product_select");
    if(related_product_selects.length){
      for (let index = 0; index < related_product_selects.length; index++) {
        related_product_selects[index].addEventListener("change", function(){
          var itemId = this.getAttribute('data-id');
          var value = this.value;
          var option = this.options[this.selectedIndex];
          var price = option.getAttribute("data-price")*1;
          var compare_at_price = option.getAttribute("data-compare-price")*1;
          var img_id = option.getAttribute("data-selectimgid");
          var variant_featured_media = option.getAttribute("data-selectimgsrc");

          var checkbox = this.closest(".frequently_bought_together__block").querySelector(".related_product_block_check[data-id='" + itemId + "']");
          checkbox.value = value;
          checkbox.setAttribute("data-price", price);
           checkbox.setAttribute("data-compare-price", compare_at_price);

          checkbox.dispatchEvent(new Event('change', { bubbles: true }));


      var current_product_image_blockEl = document.querySelector('[data-imgid="'+img_id+'"]');
       if(current_product_image_blockEl && variant_featured_media != "") {
         current_product_image_blockEl.querySelector('img').setAttribute('src',variant_featured_media);
       }
          
        
            var variantBlockEl = this.closest('.related_product_image');
       if(variantBlockEl) {
         var priceEl = variantBlockEl.querySelector('.price');
        // var  variant_checkEl = variantBlockEl.querySelector('.related_product_block_check'); 

        

          var prevPrice = priceEl.getAttribute('data-current-price') * 1;
         var prevComparePrice = priceEl.getAttribute('data-current-compare_at_price') * 1;
      var  currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
         var itemBadge = variantBlockEl.querySelector('.product-label');


         priceEl.innerHTML = '';

          if(compare_at_price > price) {

          var savings = null;
            if (window.theme.discountMode === 'percentage') {
            savings = "".concat(Math.round((compare_at_price - price) * 100 / compare_at_price), "%");
          } else {
            savings = "<span>".concat(formatMoney(compare_at_price - price, window.theme.moneyFormat), "</span>");
          }

            if (itemBadge) {
              itemBadge.style.display = '';
              itemBadge.innerHTML = window.languages.collectionOnSaleLabel.replace('{{savings}}', savings);
            }
            
            // priceEl.innerHTML += "<span class=\"product-label product-label--on-sale\">".concat(window.languages.collectionOnSaleLabel.replace('{{savings}}', savings))+"</span>";

                        priceEl.innerHTML += "<span class=\"price price--highlight\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(price, currencyFormat), "</span>");
            priceEl.innerHTML += "<span class=\"price price--compare\"><span class=\"visually-hidden\">".concat(window.languages.productRegularPrice, "</span>").concat(formatMoney(compare_at_price, currencyFormat), "</span>");

            
          } else {
            if (itemBadge) {
              itemBadge.style.display = 'none';
            }
            
            priceEl.innerHTML += "<span class=\"price\"><span class=\"visually-hidden\">".concat(window.languages.productSalePrice, "</span>").concat(formatMoney(price, currencyFormat), "</span>");
          }
         


             // variant_checkEl.dispatchEvent(new Event('change', { bubbles: true }));
         }         
       

          
          
        });
      }
    }
    
  }
  
  document.addEventListener('click', function(e) {
  	var el = e.target;
    
    if(el.classList.contains('featured_show_more_button') || el.closest('.featured_show_more_button')) {
      if(!el.classList.contains('featured_show_more_button')) {
      	el = el.closest('.featured_show_more_button');
      }

      e.preventDefault();
      var hrefEl = el.href;
      var originHref = el.getAttribute('data-href');
      var pageIndex = el.href.split('&page=')[1] * 1;
      
            
       fetch(hrefEl, {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {           

            var sectionEl = el.closest('.section');
            var AjaxinateContainerEl = sectionEl.querySelector('.AjaxinateContainer');
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
     
        if(AjaxinateContainerEl) {

          if(tempDiv.innerHTML.trim().length) {
              AjaxinateContainerEl.innerHTML = AjaxinateContainerEl.innerHTML + tempDiv.innerHTML;

            if(AjaxinateContainerEl.querySelector('.last_paginate_item')) {
               el.parentNode.style.display = 'none';
            } else {
          var new_pageIndex = pageIndex + 1;
          var new_href = originHref+'&page='+new_pageIndex;
          el.href = new_href;
            }            
          } 
        }

          });
       });

     
      
    }
  });
});
